'use client';

import {
  Children,
  type ReactElement,
  type Ref,
  cloneElement,
  isValidElement,
} from 'react';

import classnames from 'classnames';

import { useVisibleOnScroll } from '../../utils/scroll';
import type { BottomTabNavbarProps } from './BottomTabNavbar.types';
import type { MenuItemProps } from './menu/MenuItem';
import { BottomTabSubMenu, type SubMenuProps } from './menu/SubMenu';

import styles from './BottomTabNavbar.module.scss';

export function BottomTabNavbar({
  style,
  children,
  className,
  testId = 'ui-bottom-tab-navbar',
  ref,
  ...rest
}: BottomTabNavbarProps & { ref?: Ref<HTMLDivElement> }) {
  const showNavbar = useVisibleOnScroll();

  return (
    <nav
      ref={ref}
      className={classnames(
        styles['navbar'],
        showNavbar && styles['navbar--visible'],
        !showNavbar && styles['navbar--toggled'],
        className,
      )}
      style={{ ...style }}
      data-testid={testId}
      {...rest}
    >
      <ul className={styles['items']}>
        {Children.toArray(children)
          .filter(Boolean)
          .map((child, index) => {
            if (!isValidElement(child)) return child;

            if (child.type === BottomTabSubMenu) {
              return cloneElement(child as ReactElement<SubMenuProps>, {
                key: index,
                firstchild: true,
              });
            }

            return cloneElement(child as ReactElement<MenuItemProps>, {
              key: index,
            });
          })}
      </ul>
    </nav>
  );
}
